import React from 'react';
import { useMarketProgress } from '../../hooks/useMarketProgress';

/** Lista de comprobación local. Solo guarda qué casillas marcaste, en este navegador. */
export function TopicChecklist({
  topicKey,
  items
}: {
  topicKey: string;
  items: string[];
}) {
  const {
    isChecked,
    toggleCheck
  } = useMarketProgress();
  const done = items.filter((_, i) => isChecked(`${topicKey}:${i}`)).length;
  return <section aria-labelledby={`chk-${topicKey}`} className="rounded-2xl border border-white/10 bg-[#0A1628] p-4 md:p-5" data-id="element-1135" data-mp="ljbaub6uoa0n">
      <div className="flex items-baseline justify-between gap-3" data-id="element-1136" data-mp="gr07szgtc83v">
        <h2 id={`chk-${topicKey}`} className="font-cinzel text-base font-bold text-white md:text-lg" data-id="element-1137" data-mp="cq7yk67xy37l">
          Lista de comprobación
        </h2>
        <span className="text-xs text-gray-500" data-id="element-1138" data-mp="7sy1c4eb8n97">
          {done} de {items.length}
        </span>
      </div>
      <ul className="mt-3 space-y-2" data-id="element-1139" data-mp="2riec6sko6o6">
        {items.map((it, i) => {
        const id = `${topicKey}:${i}`;
        return <li key={id} data-id="element-1140" data-mp="1gncmp9aipxrt" data-mpi={i}>
              <label className="flex cursor-pointer items-start gap-3 text-sm text-gray-200" data-id="element-1141" data-mp="1gn2v5h9trik0">
                <input type="checkbox" checked={isChecked(id)} onChange={() => toggleCheck(id)} className="mt-0.5 h-4 w-4 shrink-0 accent-[#D4AF37]" data-id="element-1142" data-mp="1leb7al2jhi0v" />
                <span className={isChecked(id) ? 'text-gray-500 line-through' : ''} data-id="element-1143" data-mp="16n2clxjs56gv">{it}</span>
              </label>
            </li>;
      })}
      </ul>
      <p className="mt-3 text-xs text-gray-500" data-id="element-1144" data-mp="1zevo5bow93rq">Se guarda solo en este navegador y no prueba ninguna operación real.</p>
    </section>;
}